import React, { memo } from 'react';

import type { EcommerceCreativeName, ItemSchema } from '@pegasus/tracker';
import { Campaign } from '@shared/types/mylounge';
import { OpenCampaignCardAspectRatio, OpenCampaignCard } from '@browsing/campaign';
import { containerClass, gridWrapperClass } from '../styles';

type Props = {
    campaigns: Campaign[];
    columnCount: number;
    isPlusEnabled: boolean;
    idPrefix?: string;
    trackCreativeName?: EcommerceCreativeName;
    trackItemListName?: ItemSchema['item_list_name'];
};

const SquareLayoutComponent: React.FC<Props> = ({
    columnCount,
    campaigns,
    isPlusEnabled,
    idPrefix,
    trackCreativeName,
    trackItemListName,
}) => (
    <div className={containerClass}>
        <ul {...gridWrapperClass(columnCount)} id="campaigns-open">
            {campaigns.map((campaign, index) => (
                <OpenCampaignCard
                    key={campaign.campaignId}
                    style={{ gridColumn: 'span 1', gridRow: 'span 1' }}
                    aspectRatio={
                        columnCount === 1
                            ? OpenCampaignCardAspectRatio.Mobile
                            : OpenCampaignCardAspectRatio.Square
                    }
                    campaign={campaign}
                    isPlusEnabled={isPlusEnabled}
                    position={`${index + 1}|${columnCount}`}
                    {...(idPrefix && { id: `${idPrefix}-${campaign.campaignId}` })}
                    {...(trackCreativeName && { trackCreativeName })}
                    {...(trackItemListName && { trackItemListName })}
                />
            ))}
        </ul>
    </div>
);

export const SquareLayout = memo(SquareLayoutComponent);
